import { Highlight, themes } from "prism-react-renderer";
import { Card, CardBody, Col } from "reactstrap";
import { phpData } from "../../../../Data/Miscellaneous/Editor";
import CommonCardHeader from "../../../../Utils/CommonComponents/CommonCardHeader";
import { PhpModeTitle } from "../../../../Utils/Constants";

export default function PhpMode() {
  return (
    <Col xl={6}>
      <Card>
        <CommonCardHeader title={PhpModeTitle} />
        <CardBody>
          <Highlight theme={themes.vsDark} code={phpData} language="Java">
            {({ style, tokens, getLineProps, getTokenProps }) => (
              <pre style={style}>
                {tokens.map((line, i) => (
                  <div key={i} {...getLineProps({ line })}>
                    {line.map((token, key) => (
                      <span key={key} {...getTokenProps({ token })} />
                    ))}
                  </div>
                ))}
              </pre>
            )}
          </Highlight>
        </CardBody>
      </Card>
    </Col>
  );
}
